export default {
  data() {
    return {
      search: "",
      headers: [
        {
          text: "Nro. Orden",
          sortable: false,
          value: "numOrder"
        },
        {
          text: "PLU",
          sortable: false,
          value: "plu"
        },
        {
          text: "Descripción",
          value: "description",
          sortable: false
        },
        {
          text: "Cantidad",
          value: "quantity",
          sortable: false
        },
        {
          text: "Fecha de proxima entrega",
          value: "nextDelivery",
          sortable: false
        }
      ],
      itemsData: [
        {
          numOrder: 1,
          provider: "Farmadomicilios2",
          patientName: "Pepito2",
          totalModeratorFee: 2000,
          loadingDate: "2019-08-08"
        }
      ]
    };
  },
  props: {},
  watch: {},
  methods: {
    onRowClick(item) {
      this.$emit("row-click", item);
    }
  }
};
